// AUTOSAVE REGISTRY — editors register their flush() so "Exit my writing session" can save every pending keystroke before leaving.
const flushers = new Set();
export const registerFlush = (fn) => { flushers.add(fn); return () => flushers.delete(fn); };
export const flushAll = async () => { await Promise.allSettled([...flushers].map((fn) => Promise.resolve().then(fn))); };
